import axios from '@/lib/axios';
import ContactMailParams from '../types/ContactMailParams';

const contactMail = (data: ContactMailParams) => {
  return axios.post('/facility/contact/auth', data);
}

export default contactMail;